exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-selector .thumbnail[data-v-6f76a052]{margin-bottom:0}.file-selector .thumbnail>img[data-v-6f76a052],.file-selector .thumbnail>video[data-v-6f76a052]{max-width:140px;max-height:110px}.file-selector.well[data-v-6f76a052]{padding:10px}.file-selector .file-name[data-v-6f76a052]{padding-bottom:10px}.file-selector .allowed-types[data-v-6f76a052]{float:right;margin-top:17px}.has-error .thumbnail[data-v-6f76a052]{border-color:#a94442}", ""]);

// exports
